import { RESET_STATE } from 'store/global/actions';
import { LOAN_ROLES_ACTION_TYPE_V2 } from 'store/system/actions';

const initialState = null;

const loanRolesReducerV2 = (state = initialState, { type, payload }) => {
  switch (type) {
    case LOAN_ROLES_ACTION_TYPE_V2.GET_ROLES: {
      return payload || initialState;
    }

    case RESET_STATE:
      return initialState;

    default:
      return state;
  }
};

export default loanRolesReducerV2;
